// ============================================
// APPLICATION - Suscripcion Hook
// ============================================

import { useQuery } from '@tanstack/react-query';
import { suscripcionRepository } from '../../infrastructure/http/suscripcion.repository';
import { queryKeys } from '../query-keys';
import { useAuthStore } from '../../state/auth.store';

export const useSubscription = () => {
  const { session, accessToken } = useAuthStore();

  // Por ahora solo para hasPremiumAccess.
  // Cuando freemium pase a cobro, ampliar a: session.hasPremiumAccess || session.hasFreemiumAccess
  const isEnabled = !!(
    accessToken &&
    session &&
    session.hasPremiumAccess &&
    session.user.esPropietario
  );

  const { data, isLoading, isError, error } = useQuery({
    queryKey: queryKeys.suscripcion.all,
    queryFn: () => suscripcionRepository.getMiSuscripcion(),
    enabled: isEnabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  if (isError) {
    console.warn('[useSubscriptionStatus] Error al obtener suscripción:', error);
  }

  return {
    isLoading: isEnabled && isLoading,
    isEnabled,
    isError,
    suscripcion: data ?? null,
  };
};
